
import './Header.css'
import { ExpandLess, ExpandMore, PublicOutlined } from '@mui/icons-material'
import { Box, Button, Collapse, Divider, Drawer, Grid, Link, List, ListItem, ListItemIcon, ListItemText, Popover } from '@mui/material'
import { changeLanguage } from 'i18next'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import Images from '../assets/images'

const Header = () => {
  const { t } = useTranslation();
  const [language, setLanguage] = useState(t(`label`).toLowerCase());
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isAcademyPage = location.pathname === '/academy';
  const [anchorEl, setAnchorEl] = useState(null);
  const [list, setList] = useState(false);
  const open = Boolean(anchorEl);
  const id = open ? 'language-popover' : undefined;
  const languages = t('languages', { returnObjects: true });

  const desktopLinks = isAcademyPage
    ? [
      { label: t('academyHeader.home'), target: 'home', page: '/' },
      { label: t('academyHeader.howItWorks'), target: 'how-it-works' },
      { label: t('academyHeader.pricing'), target: 'pricing' },
    ]
    : [
      { label: t('header.sections'), target: 'sections' },
      { label: t('header.security'), target: 'security' },
      { label: t('header.academies'), target: 'academies' },
    ];

  const goToPage = (page) => {
    navigate(page)
  }

  const changeView = (page) => {
    setShowMenu(false);
    goToPage(page)
  }

  const scrollToSection = (target) => {
    const element = document.getElementById(target);

    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onChangeLanguage = (lang) => {
    changeLanguage(lang);
    setLanguage(lang);
    handleClose()
  }

  const openList = () => {
    setList(!list);
  };

  const getLanguages = () => {
    return Object.values(languages).map(({ name, flag, type }, index) => (
      <ListItem key={index} className={`language-row ${type === language ? 'active' : ''}`}
        onClick={() => { 
          onChangeLanguage(type); 
          setShowMenu(false); }}
      >
        <ListItemIcon >
          <img className='check' src={Images.suscription.checka} alt='check' />
        </ListItemIcon>
        <ListItemText primary={name} />
      </ListItem>
    ))

  }


  useEffect(() => {
    onChangeLanguage(navigator.language.includes('US') || navigator.language.includes('en') ? 'en' : 'es');
    // eslint-disable-next-line
  }, [])

  return (
    <div>
      <div className={`menu-bar ${isAcademyPage ? 'academy-theme' : ''}`}>
        <Grid className='menu-bar-content' container  >
          <Grid>
            <Link className="logo-container" onClick={() => isAcademyPage ? goToPage('/') : scrollToSection('home')}>
              <img src={isAcademyPage ? Images.tiim.logoTiim : Images.tiim.logo} alt='logo'
                onClick={() => isAcademyPage ? goToPage('/') : scrollToSection('home')}
              />
            </Link>
          </Grid>
          <Grid className='nav-links-container desktop' >
            <Grid container justifyContent="end" className='desktop-links'>
              {
                desktopLinks.map(({ label, target, page }) => (
                  <button key={label} type="button" className='menu-item desktop' onClick={() => page ? goToPage(page) : scrollToSection(target)}>
                    {label}
                  </button>
                ))
              }
            </Grid>
          </Grid>
          <Grid className='header-actions desktop'>
            <Button
              className='button-language desktop'
              variant="contained"
              onClick={handleClick}
            >
              <PublicOutlined className='language-icon' />
              {t(`label`)}
            </Button>
            <Button
              className='button-login desktop'
              variant="contained"
              onClick={() => window.location.href = "https://admin.tiimapp.com"}
            >
              {isAcademyPage ? t('academyHeader.loginButton') : t(`login`)}
            </Button>
            <Button
              className='button-contact desktop'
              variant="contained"
              onClick={() => window.location.href = "mailto:hello@tiimapp.com"}
            >
              {isAcademyPage ? t('academyHeader.registerButton') : t('header.contactButton')}
            </Button>
          </Grid>
          <Grid className='nav-links-container mobile' >
            <Grid container justifyContent="flex-end">
              <div className="menu_button mobile">
                <img className="menu_icon" alt="icon" src={Images.icons.menu}
                  onClick={() => setShowMenu(true)}
                />
              </div>
            </Grid>
          </Grid>
        </Grid>
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        disableScrollLock
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <div className='popper-language'>
          {
            Object.values(languages || {}).map(({ name, type }, index) => (
              <div key={index} className={`language-row ${type === language ? 'active' : ''}`}
                onClick={() => onChangeLanguage(type)}
              >
                <img className='check' src={Images.suscription.checka} alt='check' />
                {name}
              </div>
            ))
          }
        </div>
      </Popover>
      <Drawer anchor='right' open={showMenu} onClose={() => setShowMenu(false)}>
        <Box sx={{ width: 280 }} role="presentation"
        // onClick={() => setShowMenu(false)}
        // onKeyDown={() => setShowMenu(false)}
        >
          <>
            <h1 className="side_menu_title">{t(`header.title`)}</h1>
            <List className="side_menu_list">
              {
                t(`header.list`).map(({ label, page, section, add, email, subfix, language }, i) => (
                  <div key={`item_${i}`}>
                    <ListItem>
                      <ListItemText
                        primary={`${label} ${subfix ? subfix : ''}`}
                        style={{ paddingLeft: '8px' }}
                        onClick={() => {
                          email ?
                            window.location.href = "mailto:hello@tiimapp.com" :
                            (
                              language ?
                                openList()
                                :
                                changeView(page)

                            )
                        }}
                      />
                      {language && (list ? <ExpandLess /> : <ExpandMore />)}
                    </ListItem>
                    {
                      language &&
                      <Collapse in={list} unmountOnExit>
                        <List component="div" disablePadding>
                          {getLanguages()}
                        </List>
                      </Collapse>
                    }
                    {i !== t(`header`).length - 1 && <Divider />}
                  </div>
                ))
              }
            </List>
          </>
        </Box>
      </Drawer>
    </div>

  )
}

export default Header